<script setup lang="ts">
import type { DialogTitleProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { DialogTitle } from 'reka-ui';
import { cn } from '@/lib/utils';

type TitleSize = 'default' | 'lg';

interface SheetTitleProps extends DialogTitleProps {
  class?: HTMLAttributes['class'];
  size?: TitleSize;
}

const props = withDefaults(defineProps<SheetTitleProps>(), {
  size: 'default',
});

const delegatedProps = reactiveOmit(props, 'class', 'size');

const sizeClasses: Record<TitleSize, string> = {
  default: 'text-foreground font-semibold',
  lg: 'text-2xl font-semibold',
};
</script>

<template>
  <DialogTitle data-slot="sheet-title" :class="cn(sizeClasses[props.size], props.class)" v-bind="delegatedProps">
    <slot />
  </DialogTitle>
</template>
